export default __webpack_public_path__ + "static/media/Vanir Stonecrusher.4fca1ac8.jpg";